import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { prepareMentionSelection } from '#pplx/frontend/components/form/lexical/plugins/prepareMentionSelection.js';
/** Applies the legacy selection decision to the active Composer query. */
export function selectMentionTypeaheadOption({ option, editor, }) {
    const selection = prepareMentionSelection({ option });
    switch (selection) {
        case 'disabled':
            return;
        case 'remove-trigger':
            editor.deleteActiveTrigger();
            return;
        case 'insert-mention': {
            const { icon, label: text, localizedName, queryText, url, uuid: id, variant } = option;
            editor.insertToken({
                kind: 'mention',
                id,
                variant,
                text,
                ...(localizedName === undefined ? {} : { localizedName }),
                ...(url === undefined ? {} : { url }),
                ...(queryText === undefined ? {} : { queryText }),
                ...(icon === undefined ? {} : { icon }),
            }, { trailingSpace: true });
            return;
        }
        default:
            assertUnreachableValue(selection);
    }
}
//# sourceMappingURL=selectMentionTypeaheadOption.js.map